export var SapCompatibilityStatus;
(function (SapCompatibilityStatus) {
    SapCompatibilityStatus["SAP_COMPATIBILITY_STATUS_UNKNOWN"] = "UNKNOWN";
    SapCompatibilityStatus["SAP_COMPATIBILITY_STATUS_COMPATIBLE"] = "COMPATIBLE";
    SapCompatibilityStatus["SAP_COMPATIBILITY_STATUS_AGENT_UPGRADE_REQUIRED"] = "AGENT_UPGRADE_REQUIRED";
    SapCompatibilityStatus["SAP_COMPATIBILITY_STATUS_CONTROL_PLANE_UPGRADE_REQUIRED"] = "CONTROL_PLANE_UPGRADE_REQUIRED";
})(SapCompatibilityStatus || (SapCompatibilityStatus = {}));
